import React from "react"
import Modal from "../atoms/Modal.atom"
import PropTypes from "prop-types"
import PrimaryButton from "./buttons/PrimaryButton.molecule"
import DangerButton from "./buttons/DangerButton.molecule"
import { clsx } from "../../utils/strings.utils"

const ModalConfirmation = (props) => {
  const defaultContent = {
    title: "Titulo",
    message: "Mensaje de confirmación.",
    buttonCancelLabel: "Cancelar",
    buttonSaveLabel: "Aceptar",
  }
  const ConfirmationButton = () => {
    if (props.btnAcceptType === "danger") {
      return (
        <DangerButton
          icon="pi pi-exclamation-triangle"
          onClick={() => {
            props.onAccept()
          }}
          label={
            props.content?.buttonSaveLabel || defaultContent.buttonSaveLabel
          }
        />
      )
    }
    return (
      <PrimaryButton
        icon={clsx("pi", props.loading ? "pi-spin pi-spinner" : "pi-check")}
        onClick={() => {
          if (props.onAccept) props.onAccept()
        }}
        disabled={props.disabled}
        label={props.content?.buttonSaveLabel || defaultContent.buttonSaveLabel}
      />
    )
  }
  const showCancelButton =
    props.showCancelButton !== undefined ? props.showCancelButton : true

  return (
    <>
      <Modal
        draggable={false}
        closable={props.closable ?? false}
        onHide={props.onHide}
        className="confirmation-modal"
        visible={props.visible}
        header={
          <div className="flex align-items-center title">
            <span className="pi pi-info-circle text-3xl"></span>

            <span className="font-medium text-3xl">
              {props.content?.title || defaultContent.title}
            </span>
          </div>
        }
        footer={
          <div className="border-top-1 surface-border pt-3">
            {showCancelButton && (
              <PrimaryButton
                disabled={props.disabled}
                icon={`pi ${props.content?.buttonCancelIcon || "pi-trash"}`}
                btnType="outlined"
                onClick={() => props.onRequestCancel()}
                label={
                  props.content?.buttonCancelLabel ||
                  defaultContent.buttonCancelLabel
                }
                className="cancel-button"
              />
            )}
            <ConfirmationButton />
          </div>
        }
        modal
        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
        style={{ width: "40vw" }}
      >
        {props.content?.mainTemplate ?
          props.content?.mainTemplate()
        : <p className="line-height-3 p-0 m-0">
            {props.content?.message || defaultContent.message}
          </p>
        }
      </Modal>
    </>
  )
}

ModalConfirmation.propTypes = {
  visible: PropTypes.bool,
  onRequestCancel: PropTypes.func,
  onAccept: PropTypes.func,
  onHide: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  content: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    buttonCancelLabel: PropTypes.string,
    buttonSaveLabel: PropTypes.string,
  }),
  showCancelButton: PropTypes.bool,
}

export default ModalConfirmation
